const CancelIcon = () => {
    return (
        <i className="fa-sharp-duotone fa-solid fa-xmark"></i>
    )
}

export default CancelIcon;